
Aura.$(document).ready(function() {

  Aura.$('.parallax').each(function() {
    Aura.$(this).parallax({imageSrc: Aura.$(this).data('parallax-img')});
  });

})
